import React, { useState } from 'react';
import { useAuth } from '../data/auth';

/* ═══════════════════════════════════════════
   BILLING REQUIRED — shown when org lacks an
   active Stripe subscription and isn't
   grandfathered (billing_exempt=false).
   ═══════════════════════════════════════════ */

export default function BillingRequiredPage() {
  const auth = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleCheckout = async () => {
    setLoading(true);
    setError("");
    try {
      const resp = await fetch("/api/stripe/checkout", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          plan: "annual",
          seats: 1,
          email: auth.currentUser?.email || "",
          name: [auth.currentUser?.firstName, auth.currentUser?.lastName].filter(Boolean).join(" "),
          orgId: auth.currentUser?._orgId || null,
          return_url: window.location.origin + "/signup?session_id={CHECKOUT_SESSION_ID}",
        }),
      });
      const data = await resp.json();
      if (data.url) {
        window.location.href = data.url;
      } else {
        setError(data.error || "Failed to start checkout. Contact support.");
      }
    } catch (e) {
      setError("Checkout error: " + e.message);
    }
    setLoading(false);
  };

  const handleSignOut = async () => {
    await auth.logout();
  };

  const cardStyle = {
    width: 420, background: "#2C2E33", borderRadius: 12, border: "1px solid rgba(217,219,221,0.10)",
    padding: "32px 36px", boxShadow: "0 24px 80px rgba(0,0,0,0.5)",
  };
  const btnPrimary = {
    width: "100%", padding: "12px 0", borderRadius: 8, border: "none",
    background: "#4059AD", color: "#FAFAFA", fontSize: 13, fontWeight: 400,
    cursor: "pointer", fontFamily: "inherit", transition: "opacity 0.15s",
  };
  const linkStyle = {
    color: "rgba(250,250,250,0.5)", background: "none", border: "none", cursor: "pointer",
    fontSize: 12, fontFamily: "inherit", padding: 0, textDecoration: "underline",
  };

  return (
    <div style={{ minHeight: "100vh", background: "#1E1F23", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 24, padding: "40px 20px" }}>
      <img src="/coreflow-logo-white.png" alt="CoreFlow" style={{ height: 22, objectFit: "contain", marginBottom: 8 }} />

      <div style={cardStyle}>
        <div style={{ fontSize: 28, marginBottom: 12, textAlign: "center" }}>🔒</div>
        <div style={{ fontSize: 18, fontWeight: 400, color: "#FAFAFA", marginBottom: 8, textAlign: "center" }}>Billing required</div>
        <div style={{ fontSize: 13, color: "rgba(250,250,250,0.5)", lineHeight: 1.6, textAlign: "center", marginBottom: 24 }}>
          Your organization doesn't have an active subscription. Please complete checkout to access CoreFlow.
        </div>

        {error && (
          <div style={{ fontSize: 12, color: "#E53935", padding: "8px 12px", background: "rgba(229,57,53,0.08)", borderRadius: 8, marginBottom: 12 }}>
            {error}
          </div>
        )}

        <button onClick={handleCheckout} disabled={loading} style={{ ...btnPrimary, opacity: loading ? 0.6 : 1 }}>
          {loading ? "Redirecting to checkout..." : "Go to checkout"}
        </button>

        <div style={{ textAlign: "center", marginTop: 20, fontSize: 12, color: "rgba(250,250,250,0.4)" }}>
          Need help? <a href="mailto:support@core-flow.io" style={{ color: "#4059AD", textDecoration: "none" }}>Contact support</a>
        </div>

        <div style={{ textAlign: "center", marginTop: 12 }}>
          <button onClick={handleSignOut} style={linkStyle}>Sign out</button>
        </div>
      </div>

      <div style={{ fontSize: 11, color: "rgba(250,250,250,0.2)", marginTop: 8 }}>
        © {new Date().getFullYear()} CoreFlow. All rights reserved.
      </div>
    </div>
  );
}
